import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CustomDateFormatPipe],
  selector: 'app-last-payment',
  templateUrl: './last-payment.component.html',
  styleUrls: ['./last-payment.component.scss']
})
export class LastPaymentComponent implements OnInit {
  @Input() policy: any;
  isAcmic: boolean;
  lastPayment: any;

  constructor(private acmicService: AcmicService) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.lastPayment = this.getLastPayment();
  }

  getLastPayment(): any {
    if ((this.policy.policynumber?.policyNumber.length !== 6 && this.policy.policynumber?.policyNumber.length !== 10)
      || !this.policy.historyBills)
      return null;

    this.sortHistoryBillsByDate();

    const lastPayment = this.policy.historyBills.filter(bill => bill.datePaid)[0];
    if (!lastPayment || !lastPayment.paymentMethod) {
      return null;
    }

    let paymentMethod = "";
    if (lastPayment.paymentMethod.includes("CREDIT") || lastPayment.paymentMethod.includes("DEBIT")) {
      paymentMethod = "Credit / debit card";
    } else if (lastPayment.paymentMethod.includes("ACH")) {
      paymentMethod = (lastPayment.isRecurringPayment) ? "Recurring electronic payment" : "One time electronic payment";
    } else if (lastPayment.paymentMethod.includes("CASH")) {
      paymentMethod = (this.policy.policynumber?.policyNumber.length === 10) ? "Other Payment" : "Cash";
    }

    let paymentDate = lastPayment.datePaid;
    if (lastPayment.historyBillPayments.length) {
      const receivedPay = lastPayment.historyBillPayments
                                .find(bill => bill.transactionType.toLowerCase().includes("received"));
      
      paymentDate = receivedPay ? receivedPay.appliedDate : paymentDate;                        
    }
    return{
        amount: lastPayment.amountPaid,
        date: paymentDate,
        method: paymentMethod
    };
  }

  sortHistoryBillsByDate() {
    this.policy.historyBills.sort((a, b) => {
      if (a.datePaid > b.datePaid) return -1;
      if (a.datePaid < b.datePaid) return 1;

      if (a.transactionTime && b.transactionTime) {
        const aTime = Date.parse(a.transactionTime)
        const bTime = Date.parse(b.transactionTime)
        if (aTime > bTime) return -1;
        if (aTime < bTime) return 1;
      }

      return 0;
    })
  }
}